import config from "../config/config";
import axios from "axios";
import { getToken } from "../common";

export const createEventAPI = async (params) => {
  return await axios({
    method: "post",
    url: `${config.api.base_url}events`,
    data: params,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default createEventAPI;
